/* PeakFlex LumbarLift product page – gallery, offer add to cart (main product + free gifts), CTAs, carousels, sticky bar */
(function () {
  if (window.PFLB) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function jsonFetch(url, body) {
    var opts = { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery(gallery) {
    if (!gallery || gallery.__pflb) return;
    gallery.__pflb = true;
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-pflb-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-pflb-thumb]'));
    if (slides.length < 2) return;
    var current = 0;
    var strip = gallery.querySelector('[data-pflb-thumbs]');
    /* Keep the active thumbnail (plus a peek of its neighbour) in view */
    function reveal(t) {
      if (!strip || !t || strip.scrollWidth <= strip.clientWidth + 1) return;
      var box = strip.getBoundingClientRect();
      var r = t.getBoundingClientRect();
      var pad = r.width * 0.6;
      var dx = 0;
      if (r.left < box.left + pad) dx = r.left - box.left - pad;
      else if (r.right > box.right - pad) dx = r.right - box.right + pad;
      if (dx) strip.scrollBy({ left: dx, behavior: 'smooth' });
    }
    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) {
        var on = j === current;
        if (!on) {
          var vid = s.querySelector('video');
          if (vid) vid.pause();
        }
        s.hidden = !on;
      });
      thumbs.forEach(function (t, j) {
        t.classList.toggle('is-on', j === current);
        t.setAttribute('aria-current', j === current ? 'true' : 'false');
      });
      reveal(thumbs[current]);
    }
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { show(j); }); });

    /* Thumbnail strip: one scrollable row; mouse drag on desktop, native swipe on touch */
    if (strip) {
      var drag = null;
      strip.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (strip.scrollWidth <= strip.clientWidth + 1) return;
        drag = { x: e.clientX, left: strip.scrollLeft, moved: false };
      });
      strip.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (!drag.moved && Math.abs(dx) > 4) {
          drag.moved = true;
          strip.classList.add('is-drag');
          if (strip.setPointerCapture) strip.setPointerCapture(e.pointerId);
        }
        if (drag.moved) strip.scrollLeft = drag.left - dx;
      });
      var endDrag = function () {
        if (!drag) return;
        var moved = drag.moved;
        drag = null;
        strip.classList.remove('is-drag');
        if (moved) {
          var stop = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
          strip.addEventListener('click', stop, true);
          setTimeout(function () { strip.removeEventListener('click', stop, true); }, 250);
        }
      };
      strip.addEventListener('pointerup', endDrag);
      strip.addEventListener('pointercancel', endDrag);
    }
    var prev = gallery.querySelector('[data-pflb-prev]');
    var next = gallery.querySelector('[data-pflb-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    var main = gallery.querySelector('.pflb-gal__main');
    var startX = null;
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      startX = null;
    });
  }

  /* ---------- Hero: variant + add to cart ---------- */
  function heroConfig(hero) {
    var el = hero.querySelector('[data-pflb-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function initHero(hero) {
    if (!hero || hero.__pflb) return;
    hero.__pflb = true;
    var cfg = heroConfig(hero) || {};
    hero.__pflbVariant = cfg.variantId;
    var atc = hero.querySelector('[data-pflb-atc]');
    var label = hero.querySelector('[data-pflb-atc-label]');
    var select = hero.querySelector('[data-pflb-variant]');
    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        hero.__pflbVariant = Number(select.value);
        var now = hero.querySelector('[data-pflb-now]');
        var was = hero.querySelector('[data-pflb-was]');
        var save = hero.querySelector('[data-pflb-save]');
        if (now) now.textContent = opt.getAttribute('data-price');
        if (was) {
          was.textContent = opt.getAttribute('data-compare') || '';
          was.hidden = !opt.getAttribute('data-compare');
        }
        if (save) {
          var pct = Number(opt.getAttribute('data-save') || 0);
          var tpl = save.getAttribute('data-tpl') || save.textContent;
          save.setAttribute('data-tpl', tpl);
          save.textContent = tpl.replace(/\d+%/, pct + '%');
          save.hidden = pct <= 0;
        }
        var available = opt.getAttribute('data-available') === 'true';
        if (atc) atc.disabled = !available;
        if (label && atc) label.textContent = available ? atc.getAttribute('data-label') : atc.getAttribute('data-sold-out');
        hideError(hero);
      });
    }
    if (atc) atc.addEventListener('click', function () { addOffer(hero, atc); });
    initStickyMedia(hero);
  }

  /* ---------- Hero: gallery + review column follows the page on desktop ---------- */
  function initStickyMedia(hero) {
    var media = hero.querySelector('.pflb-hero__media--sticky');
    if (!media || !window.matchMedia) return;
    var mq = window.matchMedia('(min-width: 990px)');
    var header = document.querySelector('.section-header');
    function headerOffset() {
      if (!header) return 0;
      var cls = header.classList;
      return cls.contains('shopify-section-header-sticky') && !cls.contains('shopify-section-header-hidden') ? header.offsetHeight : 0;
    }
    function update() {
      if (!mq.matches) { media.style.top = ''; return; }
      var gap = parseFloat(getComputedStyle(hero).getPropertyValue('--pflb-sticky-top')) || 0;
      var top = headerOffset() + gap;
      var h = media.offsetHeight;
      /* Taller than the screen: stick by the bottom edge so the review stays reachable */
      if (top + h > window.innerHeight - gap) top = Math.min(top, window.innerHeight - h - gap);
      media.style.top = Math.round(top) + 'px';
    }
    update();
    window.addEventListener('resize', update);
    if (mq.addEventListener) mq.addEventListener('change', update); else if (mq.addListener) mq.addListener(update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(media);
    if (header && 'MutationObserver' in window) new MutationObserver(update).observe(header, { attributes: true, attributeFilter: ['class'] });
  }

  function showError(hero, msg) {
    var err = hero.querySelector('[data-pflb-error]');
    if (!err) return;
    err.textContent = msg;
    err.hidden = false;
  }
  function hideError(hero) {
    var err = hero.querySelector('[data-pflb-error]');
    if (err) err.hidden = true;
  }

  function cartSections() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return null;
  }

  function openDrawerWith(data) {
    var drawer = document.querySelector('cart-drawer');
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pflb-offer', cartData: data });
      }
    } catch (e) {}
    if (drawer && data.sections && typeof drawer.renderContents === 'function') {
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
    } else {
      window.location.href = (window.routes && window.routes.cart_url) || ROOT + 'cart';
    }
  }

  function addOffer(hero, button) {
    var cfg = heroConfig(hero) || {};
    var messages = cfg.messages || {};
    var variantId = hero.__pflbVariant || cfg.variantId;
    if (!variantId) return Promise.resolve();
    hideError(hero);
    var buttons = [button].concat(Array.prototype.slice.call(document.querySelectorAll('[data-pflb-action="add"]')));
    buttons.forEach(function (b) { if (b) b.classList.add('is-loading'); });

    var sections = cartSections();
    function post(items) {
      var body = { items: items };
      if (sections) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }
      return jsonFetch(ROOT + 'cart/add.js', body);
    }

    return jsonFetch(ROOT + 'cart.js')
      .then(function (r) {
        var inCart = {};
        ((r.data && r.data.items) || []).forEach(function (item) {
          if (item.properties && item.properties._pf_gift) inCart[item.variant_id] = true;
        });
        var main = { id: variantId, quantity: 1 };
        var items = [];
        if (cfg.addGifts !== false) {
          (cfg.gifts || []).forEach(function (g) {
            if (g && g.id && g.available && !inCart[g.id]) {
              items.unshift({ id: g.id, quantity: 1, properties: { _pf_gift: String(cfg.productId) } });
            }
          });
        }
        /* Shopify lists the last added line first: gifts go in reverse order and the main product last,
           so the cart shows the main product on top and the gifts in the same order as on the page. */
        items.push(main);
        return post(items).then(function (res) {
          if ((!res.ok || res.data.status) && items.length > 1) return post([main]);
          return res;
        });
      })
      .then(function (res) {
        var data = res.data || {};
        if (!res.ok || data.status) {
          showError(hero, data.description || data.message || messages.error || 'Could not add to cart. Please try again.');
          if (button && button !== hero.querySelector('[data-pflb-atc]')) scrollToBuy(hero);
          return;
        }
        openDrawerWith(data);
      })
      .catch(function () {
        showError(hero, messages.error || 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        buttons.forEach(function (b) { if (b) b.classList.remove('is-loading'); });
      });
  }

  function findHero() {
    return document.querySelector('[data-pflb-hero]');
  }

  function scrollToBuy(hero) {
    hero = hero || findHero();
    if (!hero) return;
    var target = hero.querySelector('[data-pflb-buy]') || hero;
    var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  /* ---------- Buttons elsewhere on the page ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pflb-action]');
    if (!btn) return;
    var action = btn.getAttribute('data-pflb-action');
    var hero = findHero();
    if (action === 'add' && hero) {
      e.preventDefault();
      var atc = hero.querySelector('[data-pflb-atc]');
      if (atc && atc.disabled) { scrollToBuy(hero); return; }
      addOffer(hero, btn);
    } else if (action === 'scroll' || (action === 'add' && !hero)) {
      e.preventDefault();
      scrollToBuy(hero);
    }
  });

  /* ---------- Carousels: mouse drag to scroll (touch scrolls natively) ---------- */
  function initCarousel(el) {
    if (!el || el.__pflb) return;
    el.__pflb = true;
    var drag = null;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (el.scrollWidth <= el.clientWidth + 1) return;
      drag = { x: e.clientX, left: el.scrollLeft, moved: false };
      el.classList.add('is-drag');
      if (el.setPointerCapture) el.setPointerCapture(e.pointerId);
    });
    el.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (Math.abs(dx) > 4) drag.moved = true;
      el.scrollLeft = drag.left - dx;
    });
    function end() {
      if (!drag) return;
      var moved = drag.moved;
      drag = null;
      el.classList.remove('is-drag');
      var box = el.getBoundingClientRect();
      var mid = el.scrollLeft + el.clientWidth / 2;
      var target = el.scrollLeft;
      var best = Infinity;
      Array.prototype.forEach.call(el.children, function (k) {
        var r = k.getBoundingClientRect();
        var c = r.left - box.left + el.scrollLeft + r.width / 2;
        if (Math.abs(c - mid) < best) { best = Math.abs(c - mid); target = c - el.clientWidth / 2; }
      });
      el.scrollTo({ left: target, behavior: 'smooth' });
      if (moved) {
        var stop = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
        el.addEventListener('click', stop, true);
        setTimeout(function () { el.removeEventListener('click', stop, true); }, 250);
      }
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
  }

  /* ---------- Sticky bar ---------- */
  function initSticky(bar) {
    if (!bar || bar.__pflb) return;
    bar.__pflb = true;
    var mode = bar.getAttribute('data-display');
    var wanted = mode === 'always';
    function pad() {
      var h = bar.classList.contains('is-hidden') ? 0 : bar.offsetHeight;
      document.body.style.paddingBottom = h ? h + 'px' : '';
    }
    function apply() {
      var show = wanted || bar.__forced === true;
      if (show === !bar.classList.contains('is-hidden')) return;
      bar.classList.toggle('is-hidden', !show);
      if (show) { bar.removeAttribute('inert'); bar.removeAttribute('aria-hidden'); }
      else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
      pad();
    }
    bar.__apply = apply;
    var hero = findHero();
    if (mode === 'after_hero') {
      /* Show once the visitor reaches the section after the product hero */
      var heroSection = hero ? (hero.closest('.shopify-section') || hero) : null;
      var check = function () {
        wanted = heroSection ? heroSection.getBoundingClientRect().bottom <= window.innerHeight : true;
        apply();
      };
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
    } else if (mode === 'after_buy_box') {
      var atc = hero && hero.querySelector('[data-pflb-atc]');
      if (atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          wanted = !e.isIntersecting && e.boundingClientRect.top < 0;
          apply();
        }).observe(atc);
      } else {
        wanted = true;
        apply();
      }
    } else {
      apply();
    }
    pad();
    window.addEventListener('resize', pad);
  }

  /* Theme editor: show the sticky bar while its section is selected */
  function forceSticky(e, on) {
    var bar = e.target && e.target.querySelector && e.target.querySelector('[data-pflb-sticky]');
    if (!bar) return;
    bar.__forced = on;
    if (bar.__apply) bar.__apply();
  }
  document.addEventListener('shopify:section:select', function (e) { forceSticky(e, true); });
  document.addEventListener('shopify:section:deselect', function (e) { forceSticky(e, false); });

  function init(scope) {
    scope = scope || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-pflb-gallery]'), initGallery);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-pflb-hero]'), initHero);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-pflb-carousel]'), initCarousel);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-pflb-sticky]'), initSticky);
  }

  window.PFLB = { init: init, addOffer: addOffer };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.querySelector('[data-pflb-sticky]')) document.body.style.paddingBottom = '';
  });
})();
